import { render } from "./SubTable.vue?vue&type=template&id=05f5633e&scoped=true&ts=true"
import script from "./SubTable.vue?vue&type=script&lang=ts"
export * from "./SubTable.vue?vue&type=script&lang=ts"

import "./SubTable.vue?vue&type=style&index=0&id=05f5633e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f5633e"]])

export default __exports__